import React, { FC } from 'react';

import ActionRow from './ActionRow';
import { ActionType } from 'src/actions/rules/actions';
import { StyledTypeDescription } from 'src/presentation/components/pages/rules/shared/StyledComponents';

type AddNoReplyNeededActionProps = {
  onDelete: Function;
};

const AddNoReplyNeededAction: FC<AddNoReplyNeededActionProps> = ({ onDelete }) => {
  return (
    <ActionRow type={ActionType.AddNoReplyNeeded} onDelete={onDelete}>
      <StyledTypeDescription>Mark No Reply Needed</StyledTypeDescription>
    </ActionRow>
  );
};

export default AddNoReplyNeededAction;
